import { EInsideElement } from "$src/CGS/domain/dto/core/EInsideElement";
import { InsideElementMetadata } from "../Metadata/InsideElementMetadata";
import { ApplianceInsideGenerator } from "./ApplianceInsideGenerator";
import { BaseInsideElementGenerator } from "./BaseInsideElementGenerator";
import { InsideContainerGenerator } from "./InsideContainerGenerator";
import { ShelfGenerator } from "./ShelfGenerator";

export class InsideElementGeneratorFactory {
    public static getGenerator(insideContainerGenerator: InsideContainerGenerator, insideElementMetadata: InsideElementMetadata): BaseInsideElementGenerator | null {
        switch (insideElementMetadata.Type) {
            case EInsideElement.S:
            case EInsideElement.BS:
            case EInsideElement.PB:
                return new ShelfGenerator(insideContainerGenerator, insideElementMetadata);
            case EInsideElement.A:
            case EInsideElement.DW:
            case EInsideElement.W:
            case EInsideElement.F:
                return new ApplianceInsideGenerator(insideContainerGenerator, insideElementMetadata);
            default:
                return null;
        }
    }
}